import { FluentProvider, Card, Dropdown, Option, Divider, Button, Tooltip, Title3, Subtitle2Stronger, Body1, Caption1, Subtitle2, Image, useId, Label, Spinner } from '@fluentui/react-components';
import { Alignment, Stack, StackItem } from '@fluentui/react';
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { SkeletonHome } from '../../components/skeleton/skeletonHome';
import { ToastComponent } from '../../components/toast/toast.component';
import { Feedback_Func } from '../../api/feedback/feedback_func';
import { Tenant_func } from '../../api/home/tenant_func';
import { Tenant_dev } from '../../api/home/tenant_dev';
import { GlobalContext } from '../../hooks/globalContext';
import { homeImage, parentHome, dividerStyle, homeCard, dropdownDataStyle, cardBorder, homeCardResponsive, quickLinkHeight, dashboardTheme } from '../../styles/customStyles';
import { usePermissionStore, useTenantStore } from '../../Store/permissionStore';
import type { DropdownProps } from '@fluentui/react-components';
import apiCall from '../../utility/api';

interface iSpotlightItem {
  title?: string;
  description?: string;
  navs?: any
};

interface iStackItemConfig {
  align?: Alignment;
  content?: JSX.Element;
};

export const Home = (props: Partial<DropdownProps>) => {
  const forms = { Experience: '', Expression: '', ContactMe: 'No', Email: '' };

  const [isOnline, setIsOnline] = useState(true);
  const [feedbackUnsatisfied, setFeedbackUnsatisfied]: any = useState(true);
  const [feedbackSatisfied, setFeedbackSatisfied]: any = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isCountLoader, setIsCountLoader] = useState(true);
  const [isToast, setIsToast] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [formSubmit, setFormSubmit]: any = useState(false);
  const [isChecked, setIsChecked]: any = useState(false);
  const [options, setOptions]: any = useState([]);
  const [deviceCnt, setdeviceCnt] = useState(0);
  const [oneDevicecnt, setoneDevicecnt] = useState(0);
  const [thirtyDevicecnt, setthirtyDevicecnt] = useState(0);
  const [ninetyDeviceCnt, setninetyDeviceCnt] = useState(0);
  const [formData, setFormData]: any = useState(forms);
  const [permissionsDetails, setPermissionsDetails] = useState<string[]>([]);

  const { permissions } = usePermissionStore();
  const { setTenant } = useTenantStore();

  const navigate = useNavigate();
  const contextValue = useContext(GlobalContext);
  const { tenantName, setTenantName, userSessionDetails } = contextValue;

  var userEmail: any = userSessionDetails.userEmail;
  let getEmail: any = sessionStorage.getItem('userEmail');
  if (!userEmail) {
    var userDetails: any = localStorage.getItem('userDetails');
    userEmail = userDetails?.user_email ? userDetails?.user_email : getEmail;
  }

  const dropdownId = useId('dropdown-default');
  const newdata: any = Tenant_func({ setOptions, email: userEmail });

  console.log("New Data count is: ", deviceCnt);
  console.log("New Data tenant: ", newdata);

  const navCard = (path) => {
    const container = document.querySelector('.ms-Stack.Container');
    if (container) { // container.style.height = '105vh'; // container.style.position = 'fixed'; // container.style.top = 'auto';
      console.log("Flow reaching inside default container...");
    }
    tenantName ? navigate(path) : setIsToast(true);
  };

  const navManage = () => navCard('/manage/devices/overview');
  const navAutomate = () => navCard('/automate/automation/all_automations');
  const navInvestigate = () => navCard('/investigate/analytics');

  formData.Expression = feedbackUnsatisfied ? "Satisfied" : feedbackSatisfied ? "Unsatisfied" : null;
  formData.Email = sessionStorage.getItem('userEmail');

  const role = sessionStorage.getItem('role');
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        let { data, status } = await apiCall('/administration/getPermissionSchema', { role: role });
        if (status === "success" && data?.length > 0) {
          const result = JSON.parse(data[0]?.permissionSchema);
          setPermissionsDetails(Object.keys(result));
          console.log("Permission: ", result)
        }
      } catch (error) {
        console.error("An unexpected error occurred at getPermissionList: ", error);
      } finally {
        setIsLoading(false); // Permissions have been fetched or error occurred
      }
    };
    role && fetchPermissions();
    const checkConnection = () => { setIsOnline(navigator.onLine) };
    checkConnection();
    window.addEventListener('online', checkConnection);
    window.addEventListener('offline', checkConnection);
    return () => {
      window.removeEventListener('online', checkConnection);
      window.removeEventListener('offline', checkConnection);
    };
  }, [role]);
  console.log("Checking setPermissionsDetails: ", permissionsDetails)

  useEffect(() => {
    const fetchColumnDetails = async () => {
      try {
        const { data, status } = await apiCall('/administration/getColumnData');
        if (status === "success" && data?.length > 0) {
          contextValue.setTableColumnsData(data[0]);
          localStorage.setItem("tableColumnsData", JSON.stringify(data[0]));
        }
      } catch (error) {
        console.error("Checking fetchColumnDetails error: ", error);
      };
    };
    console.log("Local: ", localStorage.getItem("tableColumnsData"));
    localStorage.getItem("tableColumnsData") === null && fetchColumnDetails();
  }, []);

  useEffect(() => {
    if (options?.length > 0) { // Sort options alphabetically by tenant name
      options.sort((a: any, b: any) => a.localeCompare(b));
      if (tenantName?.length < 1) {
        setTenantName(options[0]);
        setTenant(options[0]); // To store it in session-storage
        localStorage.setItem('tenant', options[0]);
      }
    }
  }, [options]);

  useEffect(() => {
    if (window.location.pathname !== "/Dashboard/home") {
      const mainContainer = document.getElementById("mainContainer");
      if (mainContainer) { Object.assign(mainContainer.style, homeCard) };
    }
  }, [window.location.pathname])

  const onSelectHandler = (data: any) => { // onSelect function to change the tenant access
    setTenantName(data);
    setTenant(data); // To store it in session-storage
    localStorage.setItem('tenant', data);
    if (data !== tenantName) { setIsCountLoader(true) }
  }

  useEffect(() => {
    if (!overlayOpen) {
      setFeedbackUnsatisfied(true);
      setFeedbackSatisfied(true);
      setFormData({ ...formData, Experience: "", })
      setIsChecked(false)
    }
  }, [overlayOpen]);

  const online = "/Dashboard/image/homeOnline.svg";
  const offline = "/Dashboard/image/homeOffline.svg";

  const deviceCountsLeft = [
    { label: "Total number of connected Devices", count: deviceCnt },
    { label: "Devices Reported in the Last 30 Days", count: thirtyDevicecnt },
    {
      label: "Devices that did not Report in Last 90 days",
      count: deviceCnt && (deviceCnt - ninetyDeviceCnt >= 0) ? deviceCnt - ninetyDeviceCnt : 0,
      icon: offline
    }
  ];

  const deviceCountsRight = [
    { label: "Devices Reported in the Last 1 Day", count: oneDevicecnt, icon: online },
    { label: "Devices Reported in the Last 90 days", count: ninetyDeviceCnt, icon: online }
  ];

  const managePermit: any = (permissions.includes("all") || permissionsDetails.includes("devices") || permissionsDetails.includes("apps") || permissionsDetails.includes("troubleshoot") || permissionsDetails.includes("users") || permissionsDetails.includes("administration"));

  const automatePermit: any = (permissions.includes("all") || permissions.includes("appMonitored_Read") || permissions.includes("appMonitored_Fullaccess") || permissions.includes("appMonitored_ReadandExport") || permissions.includes("appInstallation_Read") || permissions.includes("appInstallation_ReadandExport") || permissions.includes("appInstallation_Fullaccess") || permissions.includes("appUnInstall_Read") || permissions.includes("appUnInstall_ReadandExport") || permissions.includes("appUnInstall_Fullaccess") ||
    permissions.includes("appProtectProfile_Read") || permissions.includes("appProtectProfile_ReadandExport") || permissions.includes("appProtectProfile_Fullaccess") || permissionsDetails.includes("automation"))

  const feedbackItem: iStackItemConfig[] = [{ align: "start", content: <Title3> Welcome to Nanoheal's Device Management Portal </Title3> }];

  const feedbackData = () => (
    <StackItem grow shrink>
      <Stack tokens={{ childrenGap: 10 }} horizontal>
        {feedbackItem.map(({ align, content }, index) => (
          <StackItem key={index} grow shrink>
            <Stack horizontalAlign={align}> <StackItem> {content} </StackItem> </Stack>
          </StackItem>
        ))}
      </Stack>
    </StackItem>
  );

  const tenantDropdownData = () => (
    <StackItem>
      <Stack tokens={{ childrenGap: 10 }} horizontal>
        <StackItem> <Body1> Choose the Tenant that you wish to access : </Body1> </StackItem>
        <StackItem>
          <Label id={dropdownId} />
          <Tooltip withArrow content="Click here to select a Tenant" relationship="label" positioning="after">
            <Dropdown size="small" placeholder="Select a Tenant" value={tenantName} aria-labelledby={dropdownId} defaultChecked {...props}>
              <div style={dropdownDataStyle}>
                {options && Array.isArray(options)
                  ? options.map((data: any) =>
                    <Option key={data} value={data && data} onClick={() => { onSelectHandler(data) }}>
                      {data}
                    </Option>) : null
                }
              </div>
              {permissions.includes("tenant_Fullaccess") || permissions.includes("all") ?
                <Option onClick={() => navigate("/manage/administration/tenant")}> Add Tenant + </Option> : null
              }
            </Dropdown>
          </Tooltip>
          {tenantName !== '' ? <Tenant_dev propTname={tenantName} propdeviceCnt={setdeviceCnt} proponedeviceCnt={setoneDevicecnt} propthirtyDeviceCnt={setthirtyDevicecnt} propninetyDeviceCnt={setninetyDeviceCnt} setLoader={setIsCountLoader} /> : null}
        </StackItem>
      </Stack>
    </StackItem>
  );

  const deviceDataLeft = () => (
    <StackItem grow shrink>
      <Stack horizontalAlign="start">
        <Stack tokens={{ childrenGap: 10 }}>
          {deviceCountsLeft.map(({ label, count }, index) => (
            <StackItem key={index}>
              <Stack horizontal>
                <StackItem> {index !== 2 ? <Image src={online} alt="Online Icon" /> : <Image src={offline} alt="Offline Icon" />} </StackItem>
                <StackItem>
                  <Stack>
                    <StackItem> <Caption1> {label} </Caption1> </StackItem>
                    <StackItem>
                      {isCountLoader ? <Stack horizontalAlign='start'> <Spinner size='extra-tiny' label="" /> </Stack>
                        : <Subtitle2Stronger> {count} </Subtitle2Stronger>}
                    </StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </StackItem>
          ))}
        </Stack>
      </Stack>
    </StackItem>
  );

  const deviceDataRight = () => (
    <StackItem grow shrink>
      <Stack horizontalAlign="start">
        <Stack tokens={{ childrenGap: 10 }}>
          {deviceCountsRight.map(({ icon, label, count }, index) => (
            <StackItem key={index}>
              <Stack horizontal>
                <StackItem> <Image src={icon} alt={label === "Devices that did not Report in Last 90 days" ? "Offline Icon" : "Online Icon"} /> </StackItem>
                <StackItem>
                  <Stack>
                    <StackItem> <Caption1> {label} </Caption1> </StackItem>
                    <StackItem>
                      {isCountLoader ? <Stack horizontalAlign='start'> <Spinner size='extra-tiny' label="" /> </Stack>
                        : <Subtitle2Stronger> {count} </Subtitle2Stronger>}</StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </StackItem>
          ))}
        </Stack>
      </Stack>
    </StackItem>
  );

  const statusData = () => (
    <Card style={cardBorder}>
      <Stack> <Subtitle2> Status </Subtitle2> </Stack>
      <Stack tokens={{ childrenGap: 20 }} horizontal>
        <StackItem grow shrink>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            {deviceDataLeft()}
            {deviceDataRight()}
          </Stack>
        </StackItem>
      </Stack>
    </Card>
  );

  const SpotlightData = () => {
    const spots: iSpotlightItem[] = [
      { title: "Nanoheal Help", description: "Explore the Nanoheal Help Portal - Your dedicated source of expert guidance and swift solutions, ensuring you make the most of our advanced device management platform with ease", navs: undefined },
      { title: "FAQ", description: "Find answers to common queries effortlessly, empowering you to navigate our platform seamlessly and make the most of your device management experience", navs: "https://docs.nanoheal.com/books/faq/page/nanoheal-faqs" }
    ];
    return (
      <Card style={cardBorder}>
        <Stack> <Subtitle2> Spotlight </Subtitle2> </Stack>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          {spots.map(({ title, description, navs }, index) => (
            <StackItem key={index} grow shrink>
              <Stack style={parentHome} tokens={{ childrenGap: 30 }} horizontal>
                <Stack style={parentHome} verticalFill verticalAlign='space-between' tokens={{ childrenGap: 10, padding: "10px 0px" }}>
                  <Stack>
                    <Subtitle2Stronger> {title} </Subtitle2Stronger>
                    <StackItem> <Caption1> {description} </Caption1> </StackItem>
                  </Stack>
                  <StackItem> <Button appearance='outline' shape='circular' onClick={() => { navs && window.open(navs, "_blank") }}> <Body1> Know more </Body1> </Button> </StackItem>
                </Stack>
                {(index !== spots.length - 1) &&
                  <StackItem>
                    <Stack horizontal style={dividerStyle} horizontalAlign="center">
                      {Array(3).fill(<Divider appearance='strong' vertical />)}
                    </Stack>
                  </StackItem>}
              </Stack>
            </StackItem>
          ))}
        </Stack>
      </Card>
    )
  };

  const moduleCards = () => (
    <StackItem>
      <Stack tokens={{ childrenGap: 10 }} style={parentHome}>
        <Tooltip withArrow content="Click here to view Automate" relationship="label">
          <Card focusMode="off" style={{ ...cardBorder, margin: 0, ...parentHome }} onClick={automatePermit && navAutomate}>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <StackItem> <Image src="/Dashboard/image/homeNewAutomate.svg" alt="Automate Icon" /> </StackItem>
              <Stack>
                <Subtitle2> Automate </Subtitle2>
                <StackItem> <Caption1 align="justify"> The Automate module enhances operational efficiency with features like Self-help, Autoheal, Proactive, Scheduler, and Policies, allowing users to configure and manage automations that effectively streamline device issues and management. </Caption1> </StackItem>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
        <Tooltip withArrow content="Click here to Investigate the Dashboard" relationship="label">
          <Card focusMode="off" style={{ ...cardBorder, ...parentHome }} onClick={navInvestigate}>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <StackItem> <Image src="/Dashboard/image/homeNewQuicklinks.svg" alt="Investigate Icon" /> </StackItem>
              <Stack>
                <Subtitle2> Investigate </Subtitle2>
                <StackItem> <Caption1 align="justify"> The Investigate module offers a highly detailed dashboard displaying various reports on multiple aspects, including Self-help, Autoheal, Scheduler, AMX reports, Survey data, and comprehensive Asset details for better analysis. </Caption1> </StackItem>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
        <Tooltip withArrow content="Click here to Manage Tenant" relationship="label">
          <Card focusMode="off" style={{ ...cardBorder, ...parentHome }} onClick={managePermit && navManage}>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <StackItem> <Image src="/Dashboard/image/homeNewManage.svg" alt="Manage Icon" /> </StackItem>
              <Stack>
                <Subtitle2> Manage </Subtitle2>
                <StackItem> <Caption1 align="justify"> The Manage module is a complete solution for efficient device management, offering a detailed overview of devices, tools for applying remediation automations, and multiple options to deploy automation, policies, and various applications. </Caption1> </StackItem>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
      </Stack>
    </StackItem>
  );

  const homeData = () => (
    <FluentProvider theme={dashboardTheme} style={homeCardResponsive}>
      <Stack tokens={{ childrenGap: 10, padding: '20px' }} horizontalAlign="center" horizontal style={homeCardResponsive}>
        <Card size='large' style={{ ...homeImage, overflow: 'auto' }}>
          <Stack tokens={{ padding: 5 }} style={parentHome}>
            <StackItem>
              <Stack tokens={{ childrenGap: 15 }}>
                {feedbackData()}
                <StackItem> Effortlessly streamline your operations, guaranteed top-notch performance and security to all your connected devices. Immerse yourself in the seamless world of device management and elevate your operational efficiency with Nanoheal. </StackItem>
                {tenantDropdownData()}
              </Stack>
            </StackItem>
            <Stack style={{ marginTop: "0px" }} horizontalAlign='end'> <Subtitle2 style={quickLinkHeight}> Quick Links </Subtitle2> </Stack>
            <Stack tokens={{ childrenGap: 10, padding: '4px 0px 20px 0px' }} horizontal horizontalAlign='space-between'>
              <StackItem>
                <Stack verticalAlign='space-between' tokens={{ childrenGap: 10 }}>
                  {statusData()}
                  <SpotlightData />
                </Stack>
              </StackItem>
              {moduleCards()}
            </Stack>
            {isToast && <ToastComponent setmessagebar={setIsToast} toastIntent="warning" position="top" title="Select a Tenant before Navigating" />}
          </Stack>
        </Card>
      </Stack>
      <Feedback_Func formData={formData} setFormData={setFormData} setFormSubmit={setFormSubmit} formSubmit={formSubmit} />
    </FluentProvider>
  );

  return isOnline && !isLoading ? homeData() : <SkeletonHome />;
};
